import type { RegisterFormSchema } from '@/modules/register/components/RegisterForm/RegisterForm.types'

export const registerFormDefaultValues: RegisterFormSchema = {
  agreeToPrivacyPolicy: false,
  agreeToTerms: false,
  confirmPassword: '',
  email: '',
  firstName: '',
  lastName: '',
  password: '',
}
